export type WeldJobValue = string | string[] | null | undefined;

const normalizeJobParts = (jobNumber: WeldJobValue): string[] => {
  const jobValues = Array.isArray(jobNumber) ? jobNumber : [jobNumber];

  return jobValues
    .flatMap((job) => String(job ?? '').split(','))
    .map((job) => job.trim())
    .filter(Boolean);
};

export const buildWeldJobEntries = (weldNumber: string, jobNumber: WeldJobValue): string[] => {
  const jobParts = normalizeJobParts(jobNumber);

  if (jobParts.length === 0) {
    return [`${weldNumber}:`];
  }

  return jobParts.map((job) => `${weldNumber}:${job}`);
};

export const buildSelectedWeldPayload = (
  welds: Array<{ weldNumber: string; wpsNumber?: WeldJobValue; jobNumber?: WeldJobValue }>
) => {
  const selectedWeldNumbers = Array.from(new Set(welds.map((weld) => weld.weldNumber).filter(Boolean)));
  const selectedWeldAndJobNumbers = Array.from(
    new Set(welds.flatMap((weld) => buildWeldJobEntries(weld.weldNumber, weld.wpsNumber ?? weld.jobNumber)))
  );

  return {
    selectedWeldNumbers,
    selectedWeldAndJobNumbers,
  };
};
